import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import { ICON_ID } from '@gcloud-npm/utils.enums.icon-id';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';
import PropTypes from 'prop-types';
import styles from './styles';

const Bubble = ({ textBubble, className, cyData, showIcon }) => {
  return (
    <div className={`bubble ${className}`} data-cy={cyData}>
      {showIcon && (
        <div className="bubble__icon">
          <IconGlyph
            id={ICON_ID.Alerta}
            alt={ICON_ID.Alerta}
            color={COLOR_DICTIONARY.RED}
            layoutSize={{ height: 25, width: 25 }}
            cyData={`${cyData}__icon`}
          />
        </div>
      )}
      {textBubble && Array.isArray(textBubble) && (
        <div className="bubble__text">
          {textBubble.map((text, id) => {
            const key = `${cyData}${id}`;
            return (
              <Text
                key={key}
                text={text}
                size={TEXT_SIZE.CAPTION2}
                color={TEXT_COLOR.GREY5}
                display={TEXT_DISPLAY.BLOCK}
                cyData={`${cyData}__text`}
              />
            );
          })}
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

Bubble.propTypes = {
  textBubble: PropTypes.array,
  className: PropTypes.string,
  cyData: PropTypes.string,
  showIcon: PropTypes.bool,
};

Bubble.defaultProps = {
  textBubble: [''],
  className: '',
  cyData: '',
  showIcon: true,
};

export default Bubble;
